import * as React from "react";
import { getWishlisted } from "../../modules/button/utils/modules/button/utils/get-wishlisted.js";
import { getWishlistSkus } from "../../utils/utils/get-wishlist-skus.js";
import { useGetWishlist } from "./use-get-wishlist.js";
import { useWishlistActions } from "./use-wishlist-actions.js";
const useVtoWishlist = () => {
  const { data, error, loading } = useGetWishlist();
  const { addToShoppinglist, removeFromShoppinglist } = useWishlistActions("pdp");
  const wishlistedSkuItems = React.useMemo(() => getWishlistSkus(data?.items), [data?.items]);
  const onToggleWishlist = React.useCallback(
    async (sku) => {
      if (error || loading || !sku) {
        return Promise.reject();
      }
      const isWishlisted = getWishlisted(sku, data?.items);
      const action = isWishlisted ? "remove" : "add";
      if (action === "add") {
        const response = await addToShoppinglist([sku], data?.id);
        if (response.addToShoppinglist.__typename === "AddToShoppinglistSuccessResponse") {
          return Promise.resolve();
        }
      } else {
        const response = await removeFromShoppinglist([sku], data?.id);
        if (response.removeFromShoppinglist.__typename === "RemoveFromShoppinglistSuccessResponse") {
          return Promise.resolve();
        }
      }
      return Promise.reject();
    },
    [addToShoppinglist, data, error, loading, removeFromShoppinglist]
  );
  return {
    onToggleWishlist,
    wishlistedSkuItems
  };
};
export {
  useVtoWishlist
};
//# sourceMappingURL=use-vto-wishlist.js.map
